import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
@Pipe({
  name: 'dateCompare',
})
export class DateCompare implements PipeTransform {
  transform(endDate: any, accessibleDate): boolean {
    endDate = new Date(endDate);
    accessibleDate = new Date(accessibleDate);
    if (endDate < accessibleDate) {
      return true;
    }
    return false;
  }
}
